import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';

import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

import TerminalContainer from '../../containers/logistics/Terminal';
import SupplierContainer from '../../containers/logistics/Suppliers';
import CarrierContainer from '../../containers/logistics/Carriers';
import Contacts from '../../components/form/Contacts';
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPText from '../../components/pureForm/FMPText';
import FMPQuickbooksClassSelect from '../../components/pureForm/FMPQuickbooksClassSelect';
import FMPSelect from '../../components/pureForm/FMPSelect';
import FMPRegionPicker from '../../components/pureForm/FMPRegionPicker';

import { terminalProducts } from '../../libs/products';
import FMPSwitch from '../../components/pureForm/FMPSwitch';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';

const styles = (theme) => {
	const primaryColor = theme.palette.primary[500];
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		sectionDivider: {
			backgroundColor: primaryColor,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
			marginBottom: 30,
			textTransform: 'uppercase',
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		helper: {
			borderLeft: `2px solid ${theme.palette.divider}`,
			padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
			margin: '20px 0px',
			fontSize: 14,
			color: '#666',
		},
	};
};
const formFields = {
	name: '',
	addressStreet: '',
	addressCity: '',
	addressState: '',
	addressPostalCode: '',
	region: '',
	quickbooksClassId: '',
	deliveryInstructions: '',
	phoneNumber: '',
	note: '',
	supplierProducts: [
		{
			supplierId: '',
			product: '',
			loadingNumber: '',
			accountNumber: '',
			emailCopyOfDeliveryRequest: false,
			carrierNeedsToProvidePickupWindow: false,
			useStationDeliveryIdAsLoadingNumber: false,
			requireLoadingNumberPerStationOnSplitLoads: false,
			useLoadingAssignments: false,
			useAssignedLoadingNumbers: false,
			note: '',
			clearedCarrierMap: {},
		},
	],
	bulkSuppliers: [
		{
			supplierId: '',
			product: '',
			loadingNumber: '',
			note: '',
			requireLoadingNumbersFromSupplier: false,
			useBulkDeliveryIdAsLoadingNumber: false,
			clearedCarrierMap: {},
		},
	],
	contacts: [
		{
			name: '',
			title: '',
			officePhoneNumber: '',
			mobilePhoneNumber: '',
			email: '',
			note: '',
		},
	],
	deliveryEmails: [''],
	scheduleEmails: [''],
	autoInventoryRollover: false,
};

class SaveTerminal extends Component {
	constructor(props) {
		super(props);
		const terminalId = _.get(this.props, ['match', 'params', 'terminalId']);

		this.state = {
			terminalId: terminalId ? parseInt(terminalId, 10) : undefined,
			isUpdate: terminalId,
		};
		this.state = _.merge(this.state, formFields);
		this.state.bulkSuppliers = [];

		/*
		this.onChange = this.onChange.bind(this);
		this.addInput = this.addInput.bind(this);
		this.removeInput = this.removeInput.bind(this);
		this.handleSave = this.handleSave.bind(this);
		*/
	}

	componentDidMount() {
		//- Only used for updates
		const { terminal, getTerminal, suppliers, carriers } = this.props;
		const { isUpdate, terminalId } = this.state;

		if (!suppliers.length) {
			this.props.searchSuppliers();
		}

		if (!carriers.length) {
			this.props.searchCarriers();
		}

		if (!isUpdate) {
			return;
		}

		if (!terminal) {
			getTerminal({ params: { terminalIds: [terminalId] } });
		} else {
			this.updateDefaultValues(this.props);
		}
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.terminal) && !_.isUndefined(this.props.terminal)) {
			this.updateDefaultValues(this.props);
		}
	}

	updateDefaultValues(props) {
		if (!props.terminal) {
			return;
		}
		this.setState(props.terminal);
	}

	handleSave = () => {
		const { showErrors } = this.props;

		//- Check required fields
		const formFieldError = {};
		[
			{ fieldName: 'name', display: 'Terminal Name' },
			{ fieldName: 'addressStreet', display: 'Street Address' },
			{ fieldName: 'addressCity', display: 'City Address' },
			{ fieldName: 'addressState', display: 'State Address' },
			{ fieldName: 'addressPostalCode', display: 'Postal Code Address' },
			{ fieldName: 'region', display: 'Region' },
			{ fieldName: 'quickbooksClassId', display: 'Quickbooks Class' },
		].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const { supplierProducts, bulkSuppliers } = this.state;

		if (_.isEmpty(supplierProducts) && _.isEmpty(bulkSuppliers)) {
			return showErrors(['You must have at least one station or bulk supplier']);
		}

		const errors = [];
		supplierProducts.forEach((supplierProduct) => {
			const requiredFields = [
				{ display: 'Supplier', fieldName: 'supplierId' },
				{ display: 'Product TYpe', fieldName: 'product' },
			];
			requiredFields.forEach((s) => {
				if (!supplierProduct[s.fieldName]) {
					errors.push(`${s.display} is required`);
				}
			});
		});

		bulkSuppliers.forEach((bs) => {
			const requiredFields = [
				{ display: 'Supplier', fieldName: 'supplierId' },
				{ display: 'Product TYpe', fieldName: 'product' },
			];
			requiredFields.forEach((s) => {
				if (!bs[s.fieldName]) {
					errors.push(`${s.display} is required`);
				}
			});
		});

		if (errors.length) {
			showErrors(errors);
			return;
		}

		const params = {};
		[
			'name',
			'phoneNumber',
			'supplierProducts',
			'bulkSuppliers',
			'deliveryEmails',
			'scheduleEmails',
			'scheduleTiming',
			'note',
			'addressStreet',
			'addressCity',
			'addressState',
			'addressPostalCode',
			'region',
			'quickbooksClassId',
			'deliveryInstructions',
			'contacts',
		].forEach((fieldName) => {
			params[fieldName] = this.state[fieldName];
		});

		//- The DB returns the tinyint as 0/1; the API validator wants a real boolean.
		params.autoInventoryRollover = !!this.state.autoInventoryRollover;

		if (this.state.isUpdate) {
			params.terminalId = this.state.terminalId;
			this.props.updateTerminal({ params });
		} else {
			this.props.addTerminal({ params });
		}
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	/*
	handleChange = (event, path) => {
		const { type, value, checked } = event.target;
		const val = (type === 'checkbox') ? checked : value;
		const basePath = path.shift();
		let base = this.state[basePath];

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, path, val);
			this.setState({[basePath]: base });
		} else {
			this.setState({[basePath]: val});
		}
	};
	*/

	/*
	handlePureChange = _.debounce((value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	});
	*/
	handlePureChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	getInputProps = (path, md, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.handlePureChange,
			md: md || 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		const val = _.get(this.state, path, _d);
		return _.isNull(val) ? '' : val;
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { classes, terminal, suppliers, carriers } = this.props;
		const { isUpdate, contacts } = this.state;

		if (isUpdate && !terminal) {
			return <div>Fetching terminal information...</div>;
		}

		if (!suppliers || !suppliers.length || !carriers || !carriers.length) {
			return <div>Fetching suppliers...</div>;
		}

		const headline = isUpdate ? 'Update Terminal' : 'Add Terminal';
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label={headline} />

					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Terminal Info</div>
						<div className={classes.helper}>
							<em>Note</em> : Terminal name, phone number, and delivery instructions are displayed
							to customers in delivery and invoice emails.
						</div>

						<FMPText label={'Terminal Name'} {...this.getInputProps(`name`)} />

						<FMPText label={'Terminal Phone'} {...this.getInputProps(`phoneNumber`)} />

						<FMPText
							label={'Delivery Instructions'}
							helpText={'Example : Gate Codes'}
							{...this.getInputProps(`deliveryInstructions`)}
						/>

						<FMPText label={'Internal Notes'} {...this.getInputProps(`note`)} multiline={3} />

						<div className={classes.sectionHeader}>Terminal Address</div>
						<div className={classes.helper}>
							<em>Note</em> : Terminal address is displayed to customers in delivery and invoice
							emails.
						</div>

						<FMPText label={'Street'} {...this.getInputProps(`addressStreet`)} />

						<Grid container spacing={3}>
							<Grid item md={6}>
								<Grid container spacing={3}>
									<Grid item xs={5}>
										<FMPText label={'City'} {...this.getInputProps(`addressCity`)} md={12} />
									</Grid>
									<Grid item xs={3}>
										<FMPText label={'State'} {...this.getInputProps(`addressState`)} md={12} />
									</Grid>
									<Grid item xs={4}>
										<FMPText
											label={'Postal Code'}
											{...this.getInputProps(`addressPostalCode`)}
											md={12}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item md={6}>
								<FMPRegionPicker {...this.getInputProps(`region`)} md={12} />
							</Grid>
						</Grid>

						<div className={classes.sectionHeader}>Link to Quickbooks</div>
						<FMPQuickbooksClassSelect
							{...this.getInputProps(`quickbooksClassId`, '')}
							label={'Quickbooks class for vendor bill fuel line items'}
						/>

						<div className={classes.sectionHeader}>Inventory Rollover</div>
						<div className={classes.helper}>
							<em>Note</em> : When on, the FMP computes this terminal&apos;s monthly inventory
							rollover automatically from railcar purchases and deliveries, and hand-entered
							rollovers are blocked. Only turn this on for terminals where we purchase railcars.
							When off, the AP team enters the rollover by hand each month and any
							system-computed rollover rows are retired within a few minutes.
						</div>
						<FMPSwitch
							label={'Automatically compute monthly inventory rollover'}
							{...this.getInputProps(`autoInventoryRollover`, 12, false)}
							value={!!this.getValue(`autoInventoryRollover`, false)}
						/>

						<div className={classes.sectionHeader}>Delivery Emails</div>

						<div className={classes.helper}>
							<em>Note</em> : Terminals emails will be sent during station and bulk delivery to the
							emails provided.
						</div>
						{this.renderDeliveryEmails()}

						{this.renderScheduleEmails()}

						{this.renderStationSuppliers()}
						{this.renderBulkSuppliers()}

						<Contacts contacts={contacts} controller={this} />

						<div style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								Save Terminal
							</Button>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderDeliveryEmails() {
		const { classes } = this.props;
		const { deliveryEmails } = this.state;

		return (
			<div>
				{deliveryEmails.map((email, i) => {
					return (
						<Grid key={i} container spacing={3}>
							<Grid item xs={11} md={5}>
								<TextField
									value={email}
									onChange={(event) => this.onChange(event, 'deliveryEmails', i)}
									label={`Email ${i + 1}`}
									fullWidth
								/>
							</Grid>
							<Grid item xs={1}>
								<IconButton
									color="primary"
									className={classes.button}
									onClick={() => this.removeInput('deliveryEmails', i)}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					);
				})}

				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('deliveryEmails')}
				>
					ADD DELIVERY EMAIL
				</Button>
			</div>
		);
	}

	makeSupplierOptions = _.memoize((suppliers) => {
		return _.sortBy(suppliers, 'name').map((item) => {
			return { value: item.supplierId, display: item.name };
		});
	});

	makeStationProductOptions = _.memoize((products) => {
		return products.map((product) => {
			return { value: product.value, display: product.display };
		});
	});

	renderStationSuppliers = () => {
		const { classes, suppliers, carriers } = this.props;
		const { supplierProducts } = this.state;

		const supplierOptions = this.makeSupplierOptions(suppliers);
		const productOptions = this.makeStationProductOptions(terminalProducts);

		return (
			<div>
				<div className={classes.sectionHeader}>Suppliers For Station Deliveries</div>

				{supplierProducts.map((sp, i) => {
					if (!sp.clearedCarrierMap) {
						sp.clearedCarrierMap = {};
					}

					return (
						<Grid key={i} container spacing={3} className={classes.inputGroup}>
							<Grid item xs={12} md={6}>
								<FMPSelect
									label={`Supplier`}
									{...this.getInputProps(`supplierProducts.${i}.supplierId`, 12)}
									options={supplierOptions}
								/>

								<FMPSelect
									label="Product Type"
									{...this.getInputProps(`supplierProducts.${i}.product`, 12)}
									options={productOptions}
								/>

								<FMPText
									label="Loading Number"
									contained={false}
									{...this.getInputProps(`supplierProducts.${i}.loadingNumber`, 12)}
								/>
								<FMPText
									label="Account Number"
									contained={false}
									{...this.getInputProps(`supplierProducts.${i}.accountNumber`, 12)}
								/>
								<FMPText
									label="Notes"
									contained={false}
									{...this.getInputProps(`supplierProducts.${i}.note`, 12)}
								/>

								{this.renderSupplierAttribute({
									index: i,
									name: 'emailCopyOfDeliveryRequest',
									label: 'Supplier will receive fuel pickup email after carrier confirms',
								})}

								{this.renderSupplierAttribute({
									sp,
									index: i,
									name: 'useStationDeliveryIdAsLoadingNumber',
									label: 'Use Delivery ID as the loading number',
								})}

								{this.renderSupplierAttribute({
									index: i,
									name: 'carrierNeedsToProvidePickupWindow',
									label: 'Carrier needs to provide pickup window on confirmation',
								})}

								{this.renderSupplierAttribute({
									index: i,
									name: 'useLoadingAssignments',
									label: 'Populate loading numbers from FMP system',
								})}

								{this.renderSupplierAttribute({
									index: i,
									name: 'useAssignedLoadingNumbers',
									label: 'Use assigned loading numbers (per station and fuel type)',
								})}

								{this.renderSupplierAttribute({
									index: i,
									name: 'requireLoadingNumberPerStationOnSplitLoads',
									label: 'Require loading number per station on split loads',
								})}
							</Grid>

							<Grid item xs={12} md={5}>
								<FormControl component="fieldset">
									<FormLabel component="legend">Cleared Carriers</FormLabel>
									<FormGroup>
										{_.sortBy(carriers, 'name').map((carrier) => {
											const { carrierId, name } = carrier;
											const path = `supplierProducts.${i}.clearedCarrierMap.${carrierId}`;
											return (
												<FMPCheckbox
													withGrid={false}
													key={`scid${carrierId}`}
													path={path}
													label={name}
													value={`${carrierId}`}
													checked={!!sp.clearedCarrierMap[carrierId]}
													onChange={this.handlePureChange}
												/>
											);
										})}
									</FormGroup>
								</FormControl>
							</Grid>

							<Grid item xs={12} md={1}>
								<IconButton
									color="primary"
									aria-label="Delete"
									onClick={() => this.removeInput('supplierProducts', i)}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					);
				})}

				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('supplierProducts')}
				>
					{!!supplierProducts.length && 'ADD ANOTHER STATION SUPPLIER'}
					{!supplierProducts.length && 'ADD A STATION SUPPLIER'}
				</Button>
			</div>
		);
	};

	makeBulkSupplierOptions = _.memoize((suppliers) => {
		const supplierOptions = [];

		_.sortBy(suppliers, 'name').forEach((item) => {
			if (_.isEmpty(item.deliveryEmails)) {
				return;
			}
			supplierOptions.push({ value: item.supplierId, display: item.name });
		});
		return supplierOptions;
	});

	renderBulkSuppliers = () => {
		const { classes, suppliers, carriers } = this.props;
		const { bulkSuppliers } = this.state;

		const supplierOptions = this.makeBulkSupplierOptions(suppliers);
		const productOptions = this.makeStationProductOptions(terminalProducts);

		return (
			<div>
				<div className={classes.sectionHeader}>Suppliers For Bulk Deliveries</div>
				{bulkSuppliers.map((bs, i) => {
					if (!bs.clearedCarrierMap) {
						bs.clearedCarrierMap = {};
					}

					return (
						<Grid key={i} container spacing={3} className={classes.inputGroup}>
							<Grid item xs={12} md={6}>
								<FMPSelect
									label={`Supplier`}
									{...this.getInputProps(`bulkSuppliers.${i}.supplierId`, 12)}
									options={supplierOptions}
									helpText="Only showing suppliers with delivery emails"
								/>

								<FMPSelect
									label="Product Type"
									{...this.getInputProps(`bulkSuppliers.${i}.product`, 12)}
									options={productOptions}
								/>

								<FMPText
									label={'Loading Number'}
									{...this.getInputProps(`bulkSuppliers.${i}.loadingNumber`, 12)}
								/>

								<FMPText
									label={'Loading Number'}
									{...this.getInputProps(`bulkSuppliers.${i}.note`, 12)}
								/>

								{this.renderBulkSupplierAttribute({
									index: i,
									name: 'requireLoadingNumbersFromSupplier',
									label: 'Require Supplier to provide loading numbers per delivery',
								})}

								{this.renderBulkSupplierAttribute({
									index: i,
									name: 'useBulkDeliveryIdAsLoadingNumber',
									label: 'Use Bulk Delivery ID as the loading number',
								})}
							</Grid>

							<Grid item xs={12} md={5}>
								<FormControl component="fieldset">
									<FormLabel component="legend">Cleared Carriers</FormLabel>
									<FormGroup>
										{_.sortBy(carriers, 'name').map((carrier) => {
											const { carrierId, name } = carrier;
											const path = `bulkSuppliers.${i}.clearedCarrierMap.${carrierId}`;
											return (
												<FMPCheckbox
													withGrid={false}
													key={`bcid${carrierId}`}
													path={path}
													label={name}
													value={`${carrierId}`}
													checked={!!bs.clearedCarrierMap[carrierId]}
													onChange={this.handlePureChange}
												/>
											);
										})}
									</FormGroup>
								</FormControl>
							</Grid>

							<Grid item xs={12} md={1}>
								<IconButton
									color="primary"
									aria-label="Delete"
									onClick={() => this.removeInput('bulkSuppliers', i)}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					);
				})}

				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('bulkSuppliers')}
				>
					{!!bulkSuppliers.length && 'ADD ANOTHER BULK SUPPLIER'}
					{!bulkSuppliers.length && 'ADD A BULK SUPPLIER'}
				</Button>
			</div>
		);
	};

	renderSupplierAttribute({ index, name, label }) {
		return (
			<FMPSwitch
				label={label}
				withGrid={false}
				{...this.getInputProps(`supplierProducts.${index}.${name}`, 12, false)}
			/>
		);
	}

	renderBulkSupplierAttribute({ index, name, label }) {
		return (
			<div style={{ display: 'block' }}>
				<FMPSwitch
					label={label}
					withGrid={false}
					{...this.getInputProps(`bulkSuppliers.${index}.${name}`, 12, false)}
				/>
			</div>
		);
	}

	renderScheduleEmails() {
		const { classes } = this.props;
		const { scheduleEmails } = this.state;

		return (
			<>
				<div className={classes.sectionHeader}>Schedule Emails</div>
				<div className={classes.helper}>
					Add any emails that you want to receive a 30 day out delivery schedule of all station and
					bulk deliveries. This will be delivered twice a day based on the schedule selection.
				</div>

				<div>
					<FMPSelect
						label="Schedule Timing"
						{...this.getInputProps(`scheduleTiming`, 6, '10and6')}
						options={[
							{ display: 'Twice Daily: 10am & 6pm PT', value: '10and6' },
							{ display: 'Twice Daily: 6am & 3pm PT', value: '6and3' },
						]}
					/>
				</div>

				<div>
					{scheduleEmails.map((email, i) => {
						return (
							<Grid key={i} container spacing={3} alignItems="flex-end">
								<Grid item xs={11} md={5}>
									<TextField
										value={email}
										onChange={(event) => this.onChange(event, 'scheduleEmails', i)}
										label={`Email ${i + 1}`}
										fullWidth
									/>
								</Grid>
								<Grid item xs={1}>
									<IconButton
										color="primary"
										className={classes.button}
										onClick={() => this.removeInput('scheduleEmails', i)}
									>
										<DeleteIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					})}

					<Button
						variant="contained"
						className={classes.addInputButton}
						onClick={() => this.addInput('scheduleEmails')}
					>
						ADD SCHEDULE EMAIL
					</Button>
				</div>
			</>
		);
	}
}

SaveTerminal.propTypes = {
	classes: PropTypes.object.isRequired,
	getTerminal: PropTypes.func.isRequired,
	addTerminal: PropTypes.func.isRequired,
	updateTerminal: PropTypes.func.isRequired,
	searchSuppliers: PropTypes.func.isRequired,
	suppliers: PropTypes.array,
	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,
	terminal: PropTypes.object,
	showErrors: PropTypes.func,
};

export default _.flow([withStyles(styles), TerminalContainer, SupplierContainer, CarrierContainer])(
	SaveTerminal
);
